import { Box, styled, Typography } from "@material-ui/core";
import Imgix from "react-imgix";
import LocalizedLink from "../../components/localized-link";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

export const ContentListImageWrapper = styled(Imgix)(({ theme }) => ({
  height: "305px",
  width: "304px",
  borderColor: "#DDD9D2",
  borderTopRightRadius: "3px",
  borderTopLeftRadius: "3px",
  marginLeft: "-1px",
  marginTop: "-1px",
  objectFit: "cover",
  [theme.breakpoints.down(`sm`)]: {
    height: "165px",
    width: "166px"
  }
}));

export const CustomColoredDiv = styled(Box)(({ theme }) => ({
  alignSelf: "center",
  height: "4px",
  backgroundColor: "#FFBB00",
  width: "166px",
  marginBottom: "-1px",
  borderBottomRightRadius: "3px",
  borderBottomLeftRadius: "3px",
  [theme.breakpoints.up(`md`)]: {
    height: "6px",
    width: "304px"
  }
}));

export const OverflowBox = styled(`div`)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  overflowX: "auto",
  overflowY: "hidden",
  maxHeight: "320px",
  [theme.breakpoints.up(`md`)]: {
    maxHeight: "488px"
  },
  [theme.breakpoints.only(`lg`)]: {
    overflow: "hidden"
  },
  /* hide scrollbar on major browsers*/
  MsOverflowStyle: "none",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none"
  }
}));

export const CustomLocalizedLink = styled(LocalizedLink)(({ theme }) => ({
  paddingRight: "21px",
  "&:last-child": {
    paddingRight: "0"
  },
  [theme.breakpoints.down(`md`)]: {
    paddingRight: "11px",
    "&:first-child": {
      paddingLeft: "16px"
    },
    "&:last-child": {
      paddingRight: "11px"
    }
  }
}));

export const CustomArrowForward = styled(ArrowForwardIcon)(({}) => ({
  color: "#000000",
  paddingRight: "5px"
}));

export const CustomTitleText = styled(Typography)(({}) => ({
  fontSize: "1.8rem",
  lineHeight: "2rem",
  fontFamily: "Reckless"
}));

export const CustomCtaText = styled(Typography)(({}) => ({
  fontSize: "1.4rem",
  lineHeight: "2rem",
  fontFamily: "Roobert"
}));
